module.exports = __webpack_public_path__ + "static/media/bank-citi.e025d264.svg";